"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_diagnostics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "848d5bf5-0e03-47b9-81b6-809910b22759",
    "data-name": "db55093a-0afd-46cf-9b87-c389586ed4c4",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "diagnostics-mid"), /*#__PURE__*/React.createElement("path", {
    d: "M60,116v26a30,30,0,0,0,30,30h0a30,30,0,0,0,30-30h0V80a20,20,0,0,1,20-20h0a20,20,0,0,1,20,20v32",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.22,22.32C92.55,24.69,102.12,37.53,99.6,51L92.37,84.25C88.67,102.75,74.74,116,60,116S31.33,102.75,27.63,84.25L20.37,51c-2.53-13.46,7-26.29,21.37-28.67",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,19.8a2,2,0,0,1,2,2v.08a2,2,0,0,1-2,2H67.35a2,2,0,0,1-2-2v-.08a2,2,0,0,1,2-2h6.08m0-4H67.35a6,6,0,0,0-6,6v.08a6,6,0,0,0,6,6h6.08a6,6,0,0,0,6-6v-.08a6,6,0,0,0-6-6Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.66,19.8a2,2,0,0,1,2,2v.08a2,2,0,0,1-2,2H46.58a2,2,0,0,1-2-2v-.08a2,2,0,0,1,2-2h6.08m0-4H46.58a6,6,0,0,0-6,6v.08a6,6,0,0,0,6,6h6.08a6,6,0,0,0,6-6v-.08a6,6,0,0,0-6-6Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,136a12,12,0,1,1,12-12A12,12,0,0,1,160,136Z",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_diagnostics;
exports.default = _default;